import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CARD_FAB_SURGE, GET_CARD_FAB_SURGE_SUCCESS, GET_CARD_FAB_SURGE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCardFabSurge({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/cards`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_CARD_FAB_SURGE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CARD_FAB_SURGE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CARD_FAB_SURGE_ERROR, payload: error });
  }
}

export function* watchGetCardFabSurge() {
  yield takeEvery(GET_CARD_FAB_SURGE, getCardFabSurge);
}

function* getCardFabSurgeSaga() {
  yield all([fork(watchGetCardFabSurge)]);
}

export default getCardFabSurgeSaga;
